module.exports = __webpack_public_path__ + "img/labmemtest_text_nextbtn_jp.c9ea2905.png";